import { render, staticRenderFns } from "./preRegistInfoTab.vue?vue&type=template&id=70a6c537&"
import script from "./preRegistInfoTab.vue?vue&type=script&lang=js&"
export * from "./preRegistInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./preRegistInfoTab.vue?vue&type=style&index=0&id=70a6c537&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports